import { render } from "./ReportClipboard.vue?vue&type=template&id=3dea9dd0&scoped=true"
import script from "./ReportClipboard.vue?vue&type=script&lang=js"
export * from "./ReportClipboard.vue?vue&type=script&lang=js"

import "./ReportClipboard.vue?vue&type=style&index=0&id=3dea9dd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dea9dd0"]])

export default __exports__